import { Helmet } from "react-helmet-async";

const SITE_URL = "https://resineko.com";

export const Seo = ({ title, description, path = "/", jsonLd, noindex = false }) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    {noindex && <meta name="robots" content="noindex, nofollow" />}
    <link rel="canonical" href={`${SITE_URL}${path}`} />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:type" content="website" />
    <meta property="og:url" content={`${SITE_URL}${path}`} />
    <meta property="og:site_name" content="Resineko" />
    <meta property="og:locale" content="fr_FR" />
    <meta property="og:image" content={`${SITE_URL}/images/og-image.jpg`} />
    <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content="630" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:image" content={`${SITE_URL}/images/og-image.jpg`} />
    {jsonLd && (
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    )}
  </Helmet>
);
